export interface IHeader {
	label: string;
	key: string;
}

export const ClientResultsHeaders: IHeader[] = [
	{ label: "Date", key: "dateCreated" },
	{ label: "Web Id", key: "webId" },
];

export const ResultsHeaders: IHeader[] = [
	...ClientResultsHeaders.slice(0, 2),
	{ label: "Last Name", key: "lastName" },
	{ label: "First Name", key: "firstName" },
];

/* 
--- ExceleRATE HEADERS ---
*/
export const ExcelerateResultsHeaders: IHeader[] = [
	{ label: "ExceleRATE", key: "excelerateScore" },
];

export const ExcelerateInfoHeaders: IHeader[] = [
	{ label: "Employee Id", key: "employeeId" },
];

export const CoreHeaders: IHeader[] = [
	{ label: "Vehicle Type", key: "vehicleType" },
	{ label: "CORE", key: "coreScore" },
	{ label: "CORE Result", key: "cErrorResult" },
	{ label: "Trainable Result", key: "tErrorResult" },
	{ label: "Appraisal Result", key: "skillsAppraisalResult" },
	{ label: "CORE Date Administered", key: "coreDateAdministered" },
	{ label: "CORE Scored Date", key: "coreDateCompleted" },
	{ label: "CORE Evaluator", key: "coreEvaluator" },
	{ label: "CORE Comments", key: "coreComments" },
	{ label: "Course Name", key: "courseName" },
	{ label: "Commercial Driving Experience", key: "commercialDrivingExp" },
];

/* 
--- ExceleRATE V1 HEADERS ---
*/
export const VitalsV1Headers: IHeader[] = [
	{ label: "VITALS Date Completed", key: "vitalsDateCompleted" },
	{ label: "VITALS", key: "vitalsScore" },
	{ label: "VITALS Result", key: "vitalsResult" },
	{ label: "VITALS Evaluator", key: "vitalsEvaluator" },
	{ label: "VITALS Comments", key: "vitalsComments" },
];

/* 
--- ExceleRATE V2 HEADERS ---
*/
export const VitalsV2Headers: IHeader[] = [
	{ label: "Vitals Date Completed", key: "careDateCompleted" },
	{ label: "Vitals", key: "careScore" },
	{ label: "Vitals Recommendation", key: "careRecommendation" },
	{ label: "Vitals Evaluator", key: "careEvaluator" },
	{ label: "Vitals Comments", key: "careComments" },
];

/* 
--- DriveABLE V2 HEADERS ---
*/
export const DriveABLEInfoHeaders: IHeader[] = [
	{ label: "Id", key: "employeeId" },
];

export const DriveABLEResultsHeaders: IHeader[] = [
	{ label: "DriveABLE", key: "excelerateScore" },
];

export const DoreHeaders: IHeader[] = [
	{ label: "DORE", key: "coreScore" },
	{ label: "DORE Recommendation", key: "onroadRecommendation" },
	{ label: "DORE Date Administered", key: "coreDateAdministered" },
	{ label: "DORE Scored Date", key: "coreDateCompleted" },
	{ label: "DORE Evaluator", key: "coreEvaluator" },
	{ label: "DORE Comments", key: "coreComments" },
	{ label: "Course Name", key: "courseName" },
];

export const DCATHeaders: IHeader[] = [
	{ label: "DCAT Date Completed", key: "careDateCompleted" },
	{ label: "DCAT", key: "careScore" },
	{ label: "DCAT Recommendation", key: "careRecommendation" },
	{ label: "DCAT Evaluator", key: "careEvaluator" },
	{ label: "DCAT Comments", key: "careComments" },
];

export const TripInspectionHeaders: IHeader[] = [
	{ label: "Trip Inspection", key: "hasTripInspection" },
];

export const NeurapulseHeaders: IHeader[] = [
	{ label: "Neurapulse Result", key: "neurapulseState" },
	{ label: "Neurapulse Completed", key: "neurapulseCompleted" },
];
